// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------

import { createGlobalStyle } from 'styled-components';
import interRegular from '../../assets/fonts/Inter-Regular.ttf';
import interBold from './../../assets/fonts/Inter-Bold.ttf';

export const GlobalStyle = createGlobalStyle`
  :root {
    --nll-white: #FFFFFF;
    --nll-yellow: #FEEB29;
    --nll-gray01: #242424;
    --nll-gray02: #555551;
    --nll-gray03: #C1BFB8;
    --nll-gray04: #DDDBD9;
    --nll-gray05: #F4F1ED;
  }

  body {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    font-family: "Inter", sans-serif;
    font-weight: 400;
    background-color: var(--nll-gray05);
  }

  @font-face {
    font-family: "Inter";
    src: url(${interRegular}) format("truetype");
  }

  @font-face {
    font-family: "Inter";
    src: url(${interBold}) format("truetype");
    font-weight: 700;
  }

  h1, h2,p {
    margin: 0;
  }

  h1 {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 2.125rem;
    letter-spacing: -0.018rem;
  }

  h2 {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5rem;
    letter-spacing: -0.018rem;
  }

  p {
    font-family: var(--Inter);
    font-size: 1.0625rem;
    font-weight: 400;
    line-height: 1.375rem;    
    letter-spacing: -0.0256rem;
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }
`;
